import { useCloseReturnsIntakeByDriverMutation } from '../services/returnsIntake.endpoints';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '@/hooks';
import { useState } from 'react';

export const useCloseReturnsIntake = (driverId?: string) => {
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const [closeRendition, { isLoading: isClosing }] = useCloseReturnsIntakeByDriverMutation();
  const [isFinishing, setIsFinishing] = useState(false);

  const handleFinish = async () => {
    if (!driverId) return;

    setIsFinishing(true);
    try {
      await closeRendition({ driverId }).unwrap();
      showNotification('Rendición cerrada correctamente', NotificationSeverity.success);
      navigate('/business/returns-intake');
    } catch {
      showNotification('Error al cerrar la rendición', NotificationSeverity.error);
    } finally {
      setIsFinishing(false);
    }
  };

  const handleGoToStart = () => {
    navigate('/business/returns-intake');
  };

  return {
    handleFinish,
    handleGoToStart,
    isClosing: isClosing || isFinishing,
  };
};

export default useCloseReturnsIntake;
